export default __webpack_public_path__ + "static/media/PrimaryIcon.bd9a63fe.svg";